import { useFormContext, useWatch } from 'react-hook-form';
import type { OptionIndex } from '../options.ts';
import type { ProductFormValues } from '../product-form.ts';
import { reconcileVariants, type OptionAxis } from '../product-variants.ts';

export type KnownCodes = ReadonlyMap<string, string>;

export const useOptionAxes = (index: OptionIndex) => {
  const { control, getValues, setValue, formState } = useFormContext<ProductFormValues>();
  const axes = useWatch<ProductFormValues, 'options'>({ control, name: 'options' });

  const apply = (next: OptionAxis[], freshCodes: KnownCodes = new Map()) => {
    const codeOf = (valueId: string) => freshCodes.get(valueId) ?? index.valueCode(valueId);
    setValue('options', next, { shouldDirty: true, shouldValidate: formState.submitCount > 0 });
    setValue('variants', reconcileVariants(getValues('variants'), next, codeOf), { shouldDirty: true });
  };

  return { axes, apply };
};
